import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Api } from '../api';
import { AppSettingService } from '../services/app.settings';

@Injectable()
export class CommonService extends Api {
    private apiUrl: string = this.getApiUrl();

    constructor(
        private http: HttpClient,
        protected appSettings: AppSettingService
    ) {
        super();
    }

    public getPostList(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'posts', { params });
    }

    public getPostItem(id: number): Observable<any> {
        return this.http.get(this.apiUrl + 'posts/' + id);
    }

    public removePostItem(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + 'posts/delete/' + id);
    }

    public createPostItem(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'posts', params);
    }

    public updatePostItem(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'posts/update', params);
    }

    public getCategoryItem(id: number): Observable<any> {
        return this.http.get(this.apiUrl + '/maincategory/' + id);
    }
    public getCategoryList(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'maincategory', { params });
    }

    public createTagItem(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'tags', params);
    }
    public updateTagItem(id: number, params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'tags/' + id, params);
    }
    public removeTagItem(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + 'tags/' + id);
    }
    public getTagItem(id: number): Observable<any> {
        return this.http.get(this.apiUrl + 'tags/' + id);
    }
    public getTagList(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'tags', { params });
    }

    removeImageFromPost(id: string | number): Observable<any> {
        return this.http.get(this.apiUrl + 'posts/delete-image/' + id);
    }
}

